import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, X, Check, Star } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const empty = { name: "", position: "", photo: "", content: "", rating: 5, order: 0, published: true };

const AdminTestimonials = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/testimonials").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, order: Number(form.order || 0), rating: Number(form.rating || 5) };
      if (editing === "new") await api.post("/testimonials", payload);
      else await api.put(`/testimonials/${editing}`, payload);
      toast.success("Berhasil"); setEditing(null); setForm(empty); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const del = async (id) => { if (window.confirm("Hapus?")) { await api.delete(`/testimonials/${id}`); load(); } };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-display font-bold">Testimoni</h1>
          <p className="mt-1 text-sm text-zinc-500">Kelola testimoni klien.</p>
        </div>
        <button onClick={() => { setEditing("new"); setForm(empty); }} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-maroon-800 text-white font-semibold">
          <Plus size={16} /> Tambah Testimoni
        </button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((t) => (
          <div key={t.id} className="bg-white p-6 rounded-2xl border border-zinc-200">
            <div className="flex gap-0.5 mb-3">
              {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} size={14} className="fill-amber-500 text-amber-500" />)}
            </div>
            <p className="text-sm text-zinc-700 leading-relaxed">"{t.content}"</p>
            <div className="mt-4 pt-4 border-t border-zinc-100 flex items-center justify-between">
              <div>
                <div className="font-bold text-zinc-900 text-sm">{t.name}</div>
                <div className="text-xs text-zinc-500">{t.position}</div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => { setEditing(t.id); setForm(t); }} className="p-2 rounded-lg hover:bg-zinc-100"><Pencil size={14} /></button>
                <button onClick={() => del(t.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-600"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full p-10 text-center text-zinc-500">Belum ada testimoni.</div>}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-display font-bold">{editing === "new" ? "Tambah" : "Edit"} Testimoni</h3>
              <button onClick={() => setEditing(null)} className="p-2 rounded-lg hover:bg-zinc-100"><X size={18} /></button>
            </div>
            <div className="space-y-4">
              <Input label="Nama *" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
              <Input label="Jabatan" value={form.position} onChange={(v) => setForm({ ...form, position: v })} />
              <div>
                <label className="block text-sm font-semibold text-zinc-800 mb-2">Isi Testimoni *</label>
                <textarea rows={4} value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 outline-none" />
              </div>
              <div className="grid grid-cols-3 gap-3">
                <Input label="Rating" value={form.rating} onChange={(v) => setForm({ ...form, rating: v })} type="number" />
                <Input label="Urutan" value={form.order} onChange={(v) => setForm({ ...form, order: v })} type="number" />
                <div className="flex items-center pt-8">
                  <input type="checkbox" checked={form.published} onChange={(e) => setForm({ ...form, published: e.target.checked })} id="tpub" />
                  <label htmlFor="tpub" className="text-sm ml-2">Publish</label>
                </div>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button onClick={() => setEditing(null)} className="px-5 py-2.5 rounded-full border font-semibold">Batal</button>
              <button onClick={save} className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-maroon-800 text-white font-semibold"><Check size={16} /> Simpan</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Input = ({ label, value, onChange, type = "text" }) => (
  <div>
    <label className="block text-sm font-semibold text-zinc-800 mb-2">{label}</label>
    <input type={type} value={value} onChange={(e) => onChange(e.target.value)}
      className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 outline-none" />
  </div>
);

export default AdminTestimonials;
